export default "__VITE_ASSET__Bxsbz3vq__"